import React from 'react';
import Svg, { Circle } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Ellipse({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 28 28"
    >
      <Circle cx="14" cy="14" r="14" fill={iconColor} />
    </Svg>
  );
}
